<span [formGroup]="preferenceGroup" >
    <span formArrayName="items">
        <span *ngFor="let item of items.controls; let i = index" [formGroupName]="i">
            <select class="form-control" formControlName="conjunction" *ngIf="i != 0">
                <option [ngValue]="conjunctionEnum.And">{{ conjunctionEnum[conjunctionEnum.And] }}</option>
                <option [ngValue]="conjunctionEnum.Or">{{ conjunctionEnum[conjunctionEnum.Or] }}</option>
            </select>
            {{ getPollinationTypeName(item.get('pollinationType').value) }}
        <span *ngIf="item.get('pollinationType').value === pollinationTypeEnum.CarryTo || item.get('pollinationType').value === pollinationTypeEnum.CarryFrom">
          <input formControlName="geName"
                    type="text"
                    (input)="item.patchValue({geName: $event.target.value.toUpperCase()})"
                    class="form-control" /> 
                <span *ngIf="item.get('geName').pending">
                    <i class="fa fa-hourglass-half" aria-hidden="true"></i> Validating GE Name...
                </span>
                <span *ngIf="item.get('geName').errors?.invalidGeName">
                    <i class="fa fa-frown-o" aria-hidden="true"></i> Invalid GE Name: {{ item.get('geName').errors?.invalidGeName.geName }}
                </span>
                <span *ngIf="item.get('geName').valid">
                    <i class="fa fa-check" aria-hidden="true"></i>
                </span>
            </span>
        </span>
    </span>
</span>

<div *ngIf="preferenceGroup.errors?.emptyPreferenceGroup">
    <span>Click the arrow to add a new pollination type</span>
</div>



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/pollination-instructions/pollination-preference-group/pollination-preference-item-list/pollination-preference-item-list.component.html